var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarrier(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0;}.b{fill:#51566d;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336 244.996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 67.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.389,72.626l-1.226-.53L15.123,70.07a1.639,1.639,0,0,0-1.475-.9H11.856v-.506A1.653,1.653,0,0,0,10.208,67H1.64A1.649,1.649,0,0,0,0,68.668v7.756a1.01,1.01,0,0,0,1,1.025h.229c0,.04,0,.056,0,.08a2.082,2.082,0,1,0,4.163.016v-.02a.625.625,0,0,0,0-.08h6.924v.08a2.082,2.082,0,1,0,4.163.016v-.1h.518A1.014,1.014,0,0,0,18,76.428V73.558A1.008,1.008,0,0,0,17.389,72.626ZM3.308,78.819a1.278,1.278,0,1,1,1.278-1.278A1.276,1.276,0,0,1,3.308,78.819Zm7.744-2.166H5.193a2.079,2.079,0,0,0-3.77,0h-.41A.208.208,0,0,1,.8,76.432v-2.07H11.052Zm0-7.981v4.887H.8V68.672a.846.846,0,0,1,.836-.86h8.568a.852.852,0,0,1,.844.856Zm.8,1.31h1.792a.848.848,0,0,1,.764.454l.8,1.555h-3.36Zm2.536,8.837a1.278,1.278,0,1,1,1.278-1.278A1.276,1.276,0,0,1,14.391,78.819ZM17.2,76.432a.208.208,0,0,1-.209.221h-.715a2.08,2.08,0,0,0-3.77,0h-.651V72.795h3.938l1.278.563a.236.236,0,0,1,.129.217Z",
    transform: "translate(0 -67.004)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrier);
export default __webpack_public_path__ + "static/media/carrier.201a6744f637a7539d934aa13f0678b9.svg";
export { ForwardRef as ReactComponent };